import { Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Layout from './components/Layout'
import { SiteFooter } from './components/SiteFooter'
import { RouteHead } from './components/RouteHead'
import { ErrorBoundary } from './components/ErrorBoundary'
import { usePageViews } from './hooks/useAnalytics'
import Home from './pages/Home'
import {
  HowItWorks, Contact, Settings, Auth, Dashboard, NotFound, About, FAQPage, Terms,
  Privacy, LegalFaq, ForGeeks, Status, Download, Safety, Workers, Minecraft,
} from './pages/lazyPages'

const PageLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="w-6 h-6 border-2 border-cyan-500/30 border-t-cyan-500 rounded-full animate-spin" />
  </div>
)

function App() {
  usePageViews()

  return (
    <ErrorBoundary>
      <RouteHead />
      <Routes>
        <Route path="/auth" element={
          <>
            <Suspense fallback={<PageLoader />}><Auth /></Suspense>
            <SiteFooter />
          </>
        } />
        <Route path="/dashboard" element={
          <>
            <Suspense fallback={<PageLoader />}>
              <ErrorBoundary>
                <Dashboard />
              </ErrorBoundary>
            </Suspense>
            <SiteFooter />
          </>
        } />
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<Suspense fallback={<PageLoader />}><About /></Suspense>} />
          <Route path="faq" element={<Suspense fallback={<PageLoader />}><FAQPage /></Suspense>} />
          <Route path="terms" element={<Suspense fallback={<PageLoader />}><Terms /></Suspense>} />
          <Route path="privacy" element={<Suspense fallback={<PageLoader />}><Privacy /></Suspense>} />
          <Route path="legal-faq" element={<Suspense fallback={<PageLoader />}><LegalFaq /></Suspense>} />
          <Route path="how-it-works" element={<Suspense fallback={<PageLoader />}><HowItWorks /></Suspense>} />
          {/* The technical page was merged into /for-geeks (301 in public/_redirects). */}
          <Route path="how-it-works/technical" element={<Navigate to="/for-geeks" replace />} />
          <Route path="for-geeks" element={<Suspense fallback={<PageLoader />}><ForGeeks /></Suspense>} />
          <Route path="contact" element={<Suspense fallback={<PageLoader />}><Contact /></Suspense>} />
          <Route path="safety" element={<Suspense fallback={<PageLoader />}><Safety /></Suspense>} />
          <Route path="status" element={<Suspense fallback={<PageLoader />}><Status /></Suspense>} />
          <Route path="download" element={<Suspense fallback={<PageLoader />}><Download /></Suspense>} />
          <Route path="settings" element={<Suspense fallback={<PageLoader />}><Settings /></Suspense>} />
          <Route path="workers" element={<Suspense fallback={<PageLoader />}><Workers /></Suspense>} />
          <Route path="minecraft" element={<Suspense fallback={<PageLoader />}><Minecraft /></Suspense>} />
          <Route path="pricing" element={<Navigate to="/#price" replace />} />
          <Route path="*" element={<Suspense fallback={<PageLoader />}><NotFound /></Suspense>} />
        </Route>
      </Routes>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1a1a2e',
            color: '#eee6ff',
            border: '1px solid rgba(255,255,255,0.06)',
          },
        }}
      />
    </ErrorBoundary>
  )
}

export default App
